module.exports = __webpack_public_path__ + "static/media/thermometer-three-quarters.a8410c2e.svg";